import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from 'store';
import { getUnits, getSimulationResults } from 'store/units/selectors';
import type { UnitInterface } from 'store/units/types';
import { isCrusher } from 'util/unitTypeClassification';
import type { UnitTypes } from 'unitData/types';

export const isRiskAssessmentEligibleType = (unitType: UnitTypes): boolean =>
  import.meta.env.DEV || isCrusher(unitType);

export const useRiskAssessmentEligibleUnits = (): UnitInterface[] => {
  const units = useSelector(getUnits);
  const simulationResults = useSelector(getSimulationResults);

  return useMemo(
    () =>
      units.filter((unit) => {
        const result = simulationResults[unit.key];
        return (
          result?.riskAssessmentInfo != null &&
          isRiskAssessmentEligibleType(unit.type)
        );
      }),
    [units, simulationResults],
  );
};

export const useHasRiskAssessmentUnits = (): boolean => {
  return useRiskAssessmentEligibleUnits().length > 0;
};

export const useIsRiskAssessmentEligible = (id: string): boolean => {
  const unitType = useSelector(
    (state: RootState) =>
      state.unitConnGroup.present.unitState.units.find((u) => u.key === id)
        ?.type,
  );
  return unitType != null && isRiskAssessmentEligibleType(unitType);
};
